import { ITrialEligibility, NotEligibleReason } from '@pressreader/commerce-types';

import { ITrialEligibilityDto } from '../types/eligibility.dto';

function mapEligibilityDto(dto: ITrialEligibilityDto): ITrialEligibility {
    return {
        isEligible: dto.isEligible,
        notEligibleReason: dto.notEligibleReason as unknown as NotEligibleReason,
        promoCode: dto.promoCode,
    };
}

export { mapEligibilityDto };
